export const fr = {
  Authentication: {
    Profile: {
      Login: 'Connexion',
      Logout: 'Déconnexion',
    },
  },
};
